module.exports = __webpack_public_path__ + "static/media/bezier-curve.3a75a435.svg";